export default __webpack_public_path__ + "static/mdt-turtle-logo-8281363a1a639d085a0215fd0850928b.svg";